import { render, staticRenderFns } from "./ContactedTechnician.vue?vue&type=template&id=66d041be&scoped=true&"
import script from "./ContactedTechnician.vue?vue&type=script&lang=js&"
export * from "./ContactedTechnician.vue?vue&type=script&lang=js&"
import style0 from "./ContactedTechnician.vue?vue&type=style&index=0&id=66d041be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d041be",
  null
  
)

export default component.exports